import styled from "styled-components";

export const StyledCard = styled.div`
  display: flex;
  flex-direction:column;
  border-radius: 15px;
  padding: 10px;
  text-align:center;
  min-width: 300px;
  justify-content:space-between;
  align-items: center;
  border: solid 1px #8dabe2;
  box-shadow: 5px 5px 8px #8dabe2;
`;

// Search result colors per match group (1 exact, 2 probable, 3 possible).
// background tints the cards, accent colors the group header.
export const SEARCH_MATCH_GROUP_COLORS = {
  1: { background: "#e3ecfb", accent: "#608cdf" },
  2: { background: "#fff6cc", accent: "#b58900" },
  3: { background: "#ececec", accent: "#6c757d" },
};

export const StyledCardHeader = styled.span`
  display: flex;
  width:100%;
  height:60px;
  align-items:center;
  justify-content:center;
  position:relative;
`;

export const LocationIcon = styled.span`
  align-self:flex-start;
  left:10px;
  top:0;
  position:absolute;
  color:#608cdf;
  `;

export const InUseIcon = styled.span`
  align-self:flex-end;
  right:10px;
  top:0;
  position:absolute;
  color:#608cdf;
  `;

export const InUseNoteText = styled.div`
  font-size: 15px;
  font-style: italic;
  color: #608cdf;
  padding: 8px 10px 0;
  text-align: center;
  word-break: break-word;
`;
